import BaseRepository from "@/services/resources/repository";

class Repository extends BaseRepository {
    static make(model, schema) {
        return new Repository(model, schema);
    }

    getWithPeopleAndCitations() {
        return this.transformer.many(
            this.try(
                this.baseQuery()
                    .include('person-specialisations.people')
                    .include('citation-specialisations.citations')
                    .get()
            )
        );
    }

    getWithCitations() {
        return this.transformer.many(
            this.try(
                this.baseQuery()
                    .include('citation-specialisations.citations')
                    .get()
            )
        );
    }
}

export default Repository;
